import React from 'react'
import { TbVocabulary } from 'react-icons/tb'

import { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

import { DictionariesOverview } from '../Components/DictionariesOverview/DictionariesOverview'
import { DictionariesShell } from '../Components/DictionariesShell/DictionariesShell'

/** Сторінка розділу «Довідники» (`/setting`): оболонка з оглядом усередині */
const IndexPage: React.FC = () => (
    <DictionariesShell>
        <DictionariesOverview />
    </DictionariesShell>
)

export const pageConfig: IPageConfig = {
    title: 'Довідники',
    icon: <TbVocabulary />,
}

export default IndexPage
